<script lang="ts">
    export let block: Block<"keypoints">
</script>

<ul>
    {#each block.content.keypoints as { keypoint }}
        <li>
            <span
                ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <g clip-path="url(#clip0_6739_3418)">
                        <path
                            d="M17.8691 6.18945L16.8084 7.25009L21.3083 11.75H0V13.25H21.3082L16.8084 17.7497L17.8691 18.8104L24.1796 12.4999L17.8691 6.18945Z"
                            fill="#242220"
                        ></path>
                    </g>
                    <defs>
                        <clipPath id="clip0_6739_3418">
                            <rect width="24" height="24" fill="white" transform="translate(0 0.5)"></rect>
                        </clipPath>
                    </defs>
                </svg>
            </span>
            <span>{keypoint}</span>
        </li>
    {/each}
</ul>

<style lang="less">
    ul {
        display: flex;
        flex-direction: column;
        gap: 0.3rem;

        li {
            display: flex;
            align-items: flex-start;
            gap: 0.6rem;
            span {
                display: flex;
                align-items: center;
                gap: 0.6rem;
            }
        }
    }
</style>
